/**
 * Clerk UserButton 弹出菜单（Popover）的宽度，工作台侧边栏账号与首页顶栏账号
 * 共用同一值——弹层走 portal 渲染到 <body>，CSS 无法按触发器位置定位，
 * 只能在组件侧经 appearance.elements.userButtonPopoverCard（Clerk 公共 API）注入。
 * Clerk 默认 14rem（224px）→ 17.5rem（280px）。
 */
export const USER_BUTTON_POPOVER_CARD = { width: "17.5rem" };
